import React, { Component } from 'react';
import Modal from "react-bootstrap/Modal";
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import { trackPromise } from 'react-promise-tracker';
import { withSnackbar } from 'react-simple-snackbar';

class Following extends Component{
    static contextType = AuthContext;
    state = {
        data:[],
        id:null,
        modal:false
    }

    handleModalClose = () => {
        this.setState({
            modal : false
        })
    }

    handleModalConfirm = () => {
        trackPromise(
            fetch(ApiBaseUrl + "/consumer/follow/"+this.state.id,
                {
                    method: 'GET',
                    headers:
                        {
                            "Authorization": "Bearer "+this.context.token
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.props.openSnackbar(result.message)
                        if(result.success)
                            this.getFollowing('confirm');
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        )
        this.handleModalClose();
    }

    handleUnfollowClick = (id) => {
        this.setState({
            id : id,
            modal : true
        })
    }

    getFollowing = (from = 'load') => {
        trackPromise(
        fetch(ApiBaseUrl + "/consumer/following",
            {
                method: 'GET',
                headers:
                    {
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(!result.success)
                        this.props.openSnackbar(result.message)
                    else
                        this.setState({
                            data: result.data
                        });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        document.getElementById('body').className='following'
        this.getFollowing('load');
    }
    componentWillUnmount () {
        document.getElementById('body').className=''
    }

    render(){
        return(
            <React.Fragment>
                <div className="overlay">
                    <img src={`${process.env.PUBLIC_URL}/image/test-6.png`} alt=""/>
                </div>
                <Modal className="modal" dialogClassName="w-400" tabIndex="-1" id="unfollow-pop" show={this.state.modal} aria-labelledby="unfollow-pop" aria-hidden="true" role="dialog">
                    <Modal.Header className="modal-header mt-4 mr-4 ml-4">
                        <h5 className="big-alert-text"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i>Alert
                        </h5>
                        <button onClick={this.handleModalClose} type="button" className="close ml-0" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">×</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body className="modal-body mr-4 ml-4">
                        <p className="unfollow-para mt-4">Do you want to unfollow this vendor ?</p>
                    </Modal.Body>
                    <Modal.Footer className="modal-footer mb-4 mr-4 ml-4">
                        <button type="button" onClick={this.handleModalConfirm} className="btn btn-secondary" data-dismiss="modal">Yes</button>
                        <button type="button" onClick={this.handleModalClose} className="btn btn-primary red-bg" data-dismiss="modal">No</button>
                    </Modal.Footer>
                </Modal>

                <div className="choose-deals-outer p-l-0 p-r-0">
                    <div className="container">
                        <div className="row">
                            {this.state.data.length ?
                                <div className="associatehost-outer">
                                    {this.state.data.map(follow => (
                                        <div className="each--associatehost-row overlay-bg" key={follow._id}>
                                            <div className="row flex-center-md">
                                                <div className="col-sm-8 col-7">
                                                    <div className="following-outer">
                                                        <h6>{follow.name}</h6>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 col-5 text-right">
                                                    <div className="view-host-deals following-outer-btn">
                                                        <button onClick={unfollow => this.handleUnfollowClick(follow._id)} className="grad-on cart-view-btn font-weight-bold mt-0"
                                                                data-toggle="modal" data-target="#unfollow-pop">unfollow
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div> :
                                <div className="col-12 text-center text-white">
                                    You haven't followed a vendor yet
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default withSnackbar(Following,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});